import React from 'react';
import styles from './SelectType.module.css';

// Утилита для одного селекта с generic-типизацией
export type TItem<T extends string> = { id: T; name: string };

interface SelectTypeProps<T extends string> {
  title: string;
  items: TItem<T>[];
  value: T;
  onChange: (v: T) => void;
  error?: boolean;
}

export function SelectType<T extends string>({
  title,
  items,
  value,
  onChange,
  error = false,
}: SelectTypeProps<T>) {
  return (
    <div className={styles.container}>
      <label className={styles.label}>{title}</label>
      <select
        className={`${styles.select} ${error ? styles.error : ''}`}
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
      >
        {items.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectType;
